/* SAFA V19 · interactions légères (vidéos TikTok à la demande, avis, temps forts) */
(function () {
  'use strict';

  /* ---------- Vidéos TikTok : l'iframe n'est chargée qu'au clic ---------- */
  var modal = null, frame = null, lastFocus = null;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'w-tt';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Vidéo TikTok');
    modal.hidden = true;
    modal.innerHTML = '<div class="w-tt__bg" data-w-tt-close></div><div class="w-tt__box"><button type="button" class="w-tt__x" data-w-tt-close aria-label="Fermer la vidéo">×</button><div class="w-tt__frame"></div><a class="w-tt__cta" href="#offres" data-w-tt-close>Choisir mon safran</a></div>';
    document.body.appendChild(modal);
    frame = modal.querySelector('.w-tt__frame');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-w-tt-close]')) {
        var a = e.target.closest('a');
        close();
        if (a && a.getAttribute('href') === '#offres' && !document.getElementById('offres')) {
          e.preventDefault();
          var url = (window.theme && window.theme.primaryProductUrl) || '/';
          window.location.href = url + '#herat-product-buy';
        }
      }
    });
  }
  function open(id) {
    if (!/^\d{8,25}$/.test(id)) return;
    if (!modal) buildModal();
    lastFocus = document.activeElement;
    frame.innerHTML = '<iframe src="https://www.tiktok.com/player/v1/' + id + '?autoplay=1&music_info=1&description=1&rel=0" title="Vidéo TikTok" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    modal.hidden = false;
    document.documentElement.classList.add('w-lock');
    modal.querySelector('.w-tt__x').focus();
  }
  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    frame.innerHTML = '';
    document.documentElement.classList.remove('w-lock');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-w-tt]');
    if (b) { e.preventDefault(); open(b.getAttribute('data-w-tt')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- Avis : afficher la suite ---------- */
  document.querySelectorAll('[data-w-more]').forEach(function (b) { b.setAttribute('data-label', b.textContent); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-w-more]');
    if (!b) return;
    var wall = b.closest('[data-w-reviews]');
    var on = wall.classList.toggle('is-open');
    b.setAttribute('aria-expanded', on ? 'true' : 'false');
    b.textContent = on ? 'Voir moins d’avis' : (b.getAttribute('data-label') || b.textContent);
  });

  /* ---------- Temps forts : contrôle de date côté navigateur + compte à rebours ---------- */
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  var d = new Date();
  var today = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  document.querySelectorAll('[data-w-start]').forEach(function (s) {
    if (designMode) return;
    var a = s.getAttribute('data-w-start'), z = s.getAttribute('data-w-end');
    var live = (!a || today >= a) && (!z || today <= z);
    s.hidden = !live;
  });
  var cds = document.querySelectorAll('[data-w-countdown]');
  if (cds.length) {
    var tick = function () {
      cds.forEach(function (c) {
        var end = new Date(c.getAttribute('data-w-countdown')).getTime();
        var left = Math.max(0, end - Date.now());
        var dd = Math.floor(left / 864e5), hh = Math.floor(left / 36e5) % 24, mm = Math.floor(left / 6e4) % 60;
        c.querySelector('[data-d]').textContent = dd;
        c.querySelector('[data-h]').textContent = pad(hh);
        c.querySelector('[data-m]').textContent = pad(mm);
      });
    };
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Vidéos natives : lecture silencieuse quand visibles ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { rootMargin: '0px', threshold: 0.35 });
    document.querySelectorAll('video[data-w-auto]').forEach(function (v) { io.observe(v); });
  }
})();
